import MainLayout from '../layouts/main';
import ExamReportContainer from './container';

function ExamReportPage() {
  return (
    <MainLayout title={EXAM_REPORT_PAGE_TITLE}>
      <ExamReportContainer />
    </MainLayout>
  );
}

export const EXAM_REPORT_PAGE_TITLE = 'کارنامه تحلیلی آزمون';

export default ExamReportPage;
